import type { Utilities } from 'core';

import { contentTypes } from './content-types';

export function getHeaders({
  headers,
  type,
  ...props
}: {
  type: keyof typeof contentTypes;
  headers: Utilities.PlainObject;
}) {
  const contentType = type || 'urlencoded';

  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': contentTypes[contentType],
      ...headers,
    },
    type,
    ...props,
  };
}
